<template>
  <div class="header-logo-wrapper">
    <div class="toggle-sidebar" @click="toggle_sidebar">
      <feather
          v-show="showMenu"
          class="status_toggle middle sidebar-toggle"
          type="align-center"
          id="sidebar-toggle"
      ></feather>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    handleMenuVissability() {

      let name = this.$route.name

      if(name == 'ProjectsList' || name == 'UserProfile' || name == 'SinglePage') {
        this.showMenu = false
      } else {
        this.showMenu = true
      }

    },
    toggle_sidebar() {

      this.$store.dispatch('menu/opensidebar');
    },
  },
  mounted() {
    this.handleMenuVissability()
  },
  watch: {
    '$route': function () {
      this.handleMenuVissability()
    }
  }
};
</script>